import styled, { css } from 'styled-components';

export const StyledDivider = styled.div<{
  $orientation: 'horizontal' | 'vertical';
  $marginTop?: number;
  $marginBottom?: number;
  $marginLeft?: number;
  $marginRight?: number;
  $maxWidth?: number | string;
  $maxHeight?: number | string;
  $thickness?: number;
}>`
  ${({ theme, $orientation, $marginTop, $marginBottom, $marginLeft, $marginRight, $maxWidth, $maxHeight, $thickness }) => {
    const borderSize = typeof $thickness === 'number' ? `${$thickness}px` : '1px';

    if ($orientation === 'vertical') {
      return css`
        align-self: stretch;
        border-left: ${borderSize} solid ${theme.colorBorder};
        height: ${$maxHeight ?? '100%'};
        margin-left: ${$marginLeft ?? 0}px;
        margin-right: ${$marginRight ?? 0}px;
      `;
    }
    return css`
      border-bottom: ${borderSize} solid ${theme.colorBorder};
      width: ${$maxWidth ?? '100%'};
      margin-top: ${$marginTop ?? 0}px;
      margin-bottom: ${$marginBottom ?? 0}px;
    `;
  }}
`;
